// Helper function to convert CSS dimension string to a pixel value
export function cssUnitsToPixels(dimension: string, contextElement: HTMLElement): number {
  if (dimension.endsWith("px")) {
    const value = parseFloat(dimension);
    if (isNaN(value)) throw new Error(`Invalid px value: ${dimension}`);
    return value;
  }
  if (dimension.endsWith("rem")) {
    const value = parseFloat(dimension);
    if (isNaN(value)) throw new Error(`Invalid rem value: ${dimension}`);
    const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    if (isNaN(rootFontSize)) throw new Error("Could not determine root font size for rem conversion.");
    return value * rootFontSize;
  }
  if (dimension.endsWith("em")) {
    const value = parseFloat(dimension);
    if (isNaN(value)) throw new Error(`Invalid em value: ${dimension}`);
    const elementFontSize = parseFloat(window.getComputedStyle(contextElement).fontSize);
    if (isNaN(elementFontSize)) throw new Error(`Could not determine element font size for em conversion.`);
    return value * elementFontSize;
  }
  throw new Error(`Unsupported CSS unit in dimension: "${dimension}". Only 'px', 'rem', 'em' are supported.`);
}
